import { getAuthData } from 'connectors/authentication';

import { authenticationState } from './atoms';
import { defaultCurrentRmaState, defaultCheckoutState } from './defaults';
import { storageCurrentRmaSelector, storageCheckoutSelector } from './selectors';

export const initializeState = ({ set }) => {
  const authData = getAuthData();
  set(authenticationState, authData);

  let localStorageRmaData = JSON.parse(localStorage.getItem('current-rma')) || {};
  let localStorageCheckoutData = JSON.parse(localStorage.getItem('rma-checkout'));

  if (localStorageRmaData.accountId !== authData.endCustomerAccountId) {
    localStorage.setItem('current-rma', null);
    localStorage.setItem('rma-checkout', null);
    localStorageRmaData = { accountId: authData.endCustomerAccountId };
    localStorageCheckoutData = {};
  }

  set(storageCurrentRmaSelector, {
    ...defaultCurrentRmaState,
    ...localStorageRmaData,
  });

  set(storageCheckoutSelector, {
    ...defaultCheckoutState,
    ...localStorageCheckoutData,
  });
};
